export const buildProvenance = { "commitHash": "5134a047a0685c3d56b14b51234c4ff27c670f08", "branchName": "refs/heads/release/2025.2", "buildDate": "2025-08-15T02:42:40.964Z", "version": "2025.2.13043" };
